import { render, staticRenderFns } from "./SelectionDialog.vue?vue&type=template&id=881787d2&"
import script from "./SelectionDialog.vue?vue&type=script&lang=js&"
export * from "./SelectionDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectionDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports